import React, { forwardRef } from 'react';

const FilterBySearchInput = forwardRef(
	(
		{
			value,
			label,
			placeholder,
			onChange,
			onEnter,
			onKeyDown,
			isDarkMode,
			isOnHeader,
			autoComplete = 'off',
			role,
			'aria-autocomplete': ariaAutocomplete,
			'aria-expanded': ariaExpanded,
			'aria-controls': ariaControls
		},
		ref
	) => {
		const handleInputChange = (event) => {
			onChange(event);
		};

		const handleKeyDown = (event) => {
			if (onKeyDown) {
				onKeyDown(event);
			}

			if (!event.defaultPrevented && event.key === 'Enter' && onEnter) {
				onEnter();
			}
		};

		return (
			<div className="flex items-center my-2 lg:my-0 mr-2 md:mr-4 text-gray-800 dark:text-dark-text">
				{label && (
					<label className="text-sm sm:text-base mr-2 text-gray-800 dark:text-dark-text">
						{label}
					</label>
				)}
				<input
					className={`p-1.5 md:p-2 border ${isDarkMode
						? 'border-gray-500'
						: 'border-gray-300 dark:border-dark-border'} rounded-md ${isOnHeader
						? 'text-base'
						: 'text-xs sm:text-base'} bg-white dark:bg-dark-card text-gray-800 dark:text-dark-text ${isOnHeader
						? ' w-24 sm:w-36 md:w-48 lg:w-52'
						: ' w-32 sm:w-36 md:w-48 lg:w-52'}`}
					type="text"
					placeholder={placeholder}
					value={value}
					onChange={handleInputChange}
					onKeyDown={handleKeyDown}
					ref={ref}
					autoComplete={autoComplete}
					role={role}
					aria-autocomplete={ariaAutocomplete}
					aria-expanded={ariaExpanded}
					aria-controls={ariaControls}
				/>
			</div>
		);
	}
);

export default FilterBySearchInput;
